import type { FAIconName } from "@/ui/core";
import { Icon } from "@/ui/core";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface OnboardingIconContainerProps extends ViewWithTestID {
  iconName: FAIconName;
}

const OnboardingIconContainer = ({
  iconName,
  testID,
}: OnboardingIconContainerProps) => {
  const baseTestID = joinTestIDs(testID, "onboarding-icon-container");

  return (
    <Box
      alignItems="center"
      backgroundColor={ColorToken.Primary10}
      borderRadius={8}
      height={36}
      justifyContent="center"
      testID={baseTestID}
      width={36}
    >
      <Icon color={ColorToken.Primary100} name={iconName} testID={baseTestID} />
    </Box>
  );
};

export type { OnboardingIconContainerProps };
export default OnboardingIconContainer;
